// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
//   measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
// };
const firebaseConfig = {
  apiKey: "AIzaSyDM4qfEN93lQS_D3wGI05GJpnv_YG4jVzI",
  authDomain: "jevelin-78a66.firebaseapp.com",
  projectId: "jevelin-78a66",
  storageBucket: "jevelin-78a66.appspot.com",
  messagingSenderId: "673327381433",
  appId: "1:673327381433:web:ec23b8d2ec74eb4cb21468",
  measurementId: "G-6D6BTZMNSJ"
};

export default firebaseConfig;
